import React from 'react';
import {
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
    IonIcon,
    IonText,
    IonPopover
} from '@ionic/react';
import { informationCircle } from 'ionicons/icons';
import { colorTheme } from '../../utils/constants';
import { Card } from '@tremor/react';

function formatDate(date) {
    if (!date) return "N/A";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
}

function isExpired(date) {
    if (!date) return false;
    const today = new Date();
    const expiryDate = new Date(date);
    return expiryDate < today;
}

export default function SubscriptionBalance({ subscriptionAmount = 0, subscriptionExpiryDate = null, currency = "", onClick }) {
    const expired = isExpired(subscriptionExpiryDate);

    return (
        <Card className="mb-3" style={{ height: "fit-content", borderRadius: "10px" }}>
            <IonCardHeader>
                <IonCardTitle className="text-center">
                    Subscription Balance
                </IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
                <IonGrid>
                    <IonRow className='mt-2' style={{ display: "flex", justifyContent: "space-around", alignItems: "center" }}>
                        <IonCol className='mt-2'>
                            <IonText>
                                <h5>Balance ({currency}) <IonIcon id="subscriptionBalanceInfo" icon={informationCircle} className="ml-2" /></h5>
                                <IonPopover trigger="subscriptionBalanceInfo">
                                    <IonText>This is the amount of your current subscription balance.</IonText>
                                </IonPopover>
                                <IonText color="primary" style={{ fontSize: '1.5em' }}>
                                    {subscriptionAmount.toLocaleString("en-US")}
                                </IonText>
                            </IonText>
                        </IonCol>
                        <IonCol className='mt-2'>
                            <IonText>
                                <h5>Subscription Expiry <IonIcon id="subscriptionExpiryInfo" icon={informationCircle} className="ml-2" /></h5>
                                <IonPopover trigger="subscriptionExpiryInfo">
                                    <IonText>This is the date when your subscription will expire.</IonText>
                                </IonPopover>
                                <IonText color="primary" style={{ fontSize: '1.5em' }}>
                                    {subscriptionExpiryDate ? formatDate(subscriptionExpiryDate) : 'N/A'}
                                </IonText>
                            </IonText>
                        </IonCol>
                        <IonButton
                            className='mt-2 mr-2'
                            onClick={onClick}
                            fill='outline'
                            id='paySubscriptionButton'
                            style={{
                                borderRadius: "10px",
                                height: "fit-content"
                            }}
                            data-testid="pay-subscription-button"
                        >
                            Pay Subscription
                        </IonButton>
                    </IonRow>
                </IonGrid>
            </IonCardContent>
        </Card>
    );
}
